// @flow
/**
 * @module Actions/Categoria
 * @desc Actions for Categoria
 */
import { ActionTypes } from '../utils/constants';

/**
 * Fetch all info from version
 * @returns {Object}
 */
export function fetchInfoFromVersionColor(tipo, modelo, version, anio) {
  return {
    type: ActionTypes.FETCH_VERSION_COLOR_INFO_REQUEST,
    payload: {
      version,
      anio,
      modelo,
      tipo,
    },
  };
}

/**
 * Fetch all info from version
 * @returns {Object}
 */
export function fetchInfoFromVersionColorSuccess(data) {
  return {
    type: ActionTypes.FETCH_VERSION_COLOR_INFO_SUCCESS,
    payload: data,
  };
}

/**
 * Fetch all info from version
 * @returns {Object}
 */
export function fetchInfoFromVersionColorFailure(version, anio) {
  return {
    type: ActionTypes.FETCH_VERSION_COLOR_INFO_FAILURE,
    payload: {
      version,
      anio,
    },
  };
}

/**
 * Select accessory request
 * @param {String} tipo
 * @param {String} modelo
 * @param {String} version
 * @param {String} anio
 * @param {String} color
 * @param {Object} accessory
 * @returns {Object}
 */
export function selectAccessoryRequest(
  tipo,
  modelo,
  version,
  anio,
  color,
  accessory
) {
  return {
    type: ActionTypes.SELECT_ACCESSORY_REQUEST,
    payload: {
      tipo,
      modelo,
      version,
      anio,
      color,
      accessory,
    },
  };
}

/**
 * Select accessory success
 * @returns {Object}
 */
export function selectAccessorySuccess() {
  return {
    type: ActionTypes.SELECT_ACCESSORY_SUCCESS,
  };
}

/**
 * Select accessory failure
 * @returns {Object}
 */
export function selectAccessoryFailure() {
  return {
    type: ActionTypes.SELECT_ACCESSORY_FAILURE,
  };
}

/**
 * Select maintenance
 * @returns {Object}
 */
export function selectMaintenance(
  tipo,
  modelo,
  version,
  anio,
  color,
  maintenanceId,
  state
) {
  return {
    type: ActionTypes.SELECT_MAINTENANCE_REQUEST,
    payload: {
      tipo,
      modelo,
      version,
      anio,
      color,
      maintenanceId,
      state,
    },
  };
}

/**
 * Select maintenance Success
 * @returns {Object}
 */
export function selectMaintenanceSuccess() {
  return {
    type: ActionTypes.SELECT_MAINTENANCE_SUCCESS,
  };
}

/**
 * Select maintenance Failure
 * @returns {Object}
 */
export function selectMaintenanceFailure() {
  return {
    type: ActionTypes.SELECT_MAINTENANCE_FAILURE,
  };
}

/**
 * Choose insurance request
 * @param {String} tipo
 * @param {String} modelo
 * @param {String} version
 * @param {String} anio
 * @param {String} color
 * @param {String} insurance
 * @returns {Object}
 */
export function chooseInsuranceRequest(
  tipo,
  modelo,
  version,
  anio,
  color,
  insurance
) {
  return {
    type: ActionTypes.CHOOSE_INSURANCE_REQUEST,
    payload: {
      tipo,
      modelo,
      version,
      anio,
      color,
      insurance,
    },
  };
}

/**
 * Choose insurance success
 * @returns {Object}
 */
export function chooseInsuranceSuccess() {
  return {
    type: ActionTypes.CHOOSE_INSURANCE_SUCCESS,
  };
}

/**
 * Choose insurance failure
 * @returns {Object}
 */
export function chooseInsuranceFailure() {
  return {
    type: ActionTypes.CHOOSE_INSURANCE_FAILURE,
  };
}

/**
 * Change prime percentage request
 * @param {String} tipo
 * @param {String} modelo
 * @param {String} version
 * @param {String} anio
 * @param {String} color
 * @param {Number} percentage
 * @returns {Object}
 */
export function changePrimePercentageRequest(
  tipo,
  modelo,
  version,
  anio,
  color,
  percentage
) {
  return {
    type: ActionTypes.CHANGE_PRIME_PERCENTAGE_REQUEST,
    payload: {
      tipo,
      modelo,
      version,
      anio,
      color,
      percentage,
    },
  };
}

/**
 * Change prime percentage success
 * @returns {Object}
 */
export function changePrimePercentageSuccess() {
  return {
    type: ActionTypes.CHANGE_PRIME_PERCENTAGE_SUCCESS,
  };
}

/**
 * Change prime percentage failure
 * @returns {Object}
 */
export function changePrimePercentageFailure() {
  return {
    type: ActionTypes.CHANGE_PRIME_PERCENTAGE_FAILURE,
  };
}

/**
 * Choose financing option request
 * @param {String} tipo
 * @param {String} modelo
 * @param {String} version
 * @param {String} anio
 * @param {String} color
 * @param {String} option
 * @returns {Object}
 */
export function chooseFinancingOptionRequest(
  tipo,
  modelo,
  version,
  anio,
  color,
  option
) {
  return {
    type: ActionTypes.CHOOSE_FINANCING_OPTION_REQUEST,
    payload: {
      tipo,
      modelo,
      version,
      anio,
      color,
      option,
    },
  };
}

/**
 * Choose financing option success
 * @returns {Object}
 */
export function chooseFinancingOptionSuccess() {
  return {
    type: ActionTypes.CHOOSE_FINANCING_OPTION_SUCCESS,
  };
}

/**
 * Choose financing option failure
 * @returns {Object}
 */
export function chooseFinancingOptionFailure() {
  return {
    type: ActionTypes.CHOOSE_FINANCING_OPTION_FAILURE,
  };
}




/**
 * Change plazo request
 * @param {String} tipo
 * @param {String} modelo
 * @param {String} version
 * @param {String} anio
 * @param {String} color
 * @param {Number} plazo
 * @returns {Object}
 */
export function changePlazoRequest(
  tipo,
  modelo,
  version,
  anio,
  color,
  plazo
) {
  return {
    type: ActionTypes.CHANGE_PLAZO_REQUEST,
    payload: {
      tipo,
      modelo,
      version,
      anio,
      color,
      plazo,
    },
  };
}

/**
 * Change plazo success
 * @returns {Object}
 */
export function changePlazoSuccess() {
  return {
    type: ActionTypes.CHANGE_PLAZO_SUCCESS,
  };
}

/**
 * Change plazo failure
 * @returns {Object}
 */
export function changePlazoFailure() {
  return {
    type: ActionTypes.CHANGE_PLAZO_FAILURE,
  };
}

/**
 * Change plazo failure
 * @returns {Object}
 */
export function getClientInfo(
  tipo,
  modelo,
  version,
  anio,
  color,
  id, 
  callback
) {
  return {
    type: ActionTypes.REQUEST_CLIENT_INFO,
    payload: {
      id,
      tipo,
      modelo,
      version,
      anio,
      color,
      callback
    }
  };
}

/**
 * Change plazo failure
 * @returns {Object}
 */
export function getClientInfoFailure(
) {
  return {
    type: ActionTypes.REQUEST_CLIENT_FAILURE,
    payload: {
    }
  };
}

/**
 * Change plazo failure
 * @returns {Object}
 */
export function getClientInfoSuccess(
  model
) {
  return {
    type: ActionTypes.REQUEST_CLIENT_SUCCESS,
    payload: {
      model: model?.data
    }
  };
}